import { format } from "date-fns";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link } from "react-router-dom";

import { useTranslation, useLocale } from "@/lib/i18n";
import { getDateFnsLocale } from "@/lib/date-fns-locale";

import Styled from "./styles";

const EarlyWarningToday = () => {
  const { t } = useTranslation();
  const locale = useLocale();

  return (
    <Link
      to="https://www.knmi.nl/nederland-nu/weer/waarschuwingen"
      target="_blank"
      style={{ textDecoration: "none" }}
    >
      <Styled.WarningToday
        direction="row"
        gap={1}
        alignItems="center"
        justifyContent="space-between"
      >
        <div>
          {t("widgets.early_warning.view_today_intro")} <br />
          <strong>
            {t("widgets.early_warning.today")}{" "}
            {format(new Date(), "eeeeee d MMM", { locale: getDateFnsLocale(locale) })}
          </strong>
        </div>
        <OpenInNewIcon />
      </Styled.WarningToday>
    </Link>
  );
};

export default EarlyWarningToday;
